import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { usePlatform } from './BrandProvider';

export default function CookieBanner() {
  const { legal } = usePlatform();
  const text = legal.cookieBannerText?.trim();
  const [ack, setAck] = useState(() => localStorage.getItem('nexora.cookieAck') === text);
  if (!text || ack || window.location.pathname.startsWith('/dev')) return null;
  const ok = () => { localStorage.setItem('nexora.cookieAck', text); setAck(true); };
  return (
    <div data-testid="cookie-banner" className="fixed inset-x-3 bottom-3 sm:left-auto sm:right-4 sm:bottom-4 sm:max-w-md z-50 glass glass-edge rounded-2xl p-4 rise pb-safe">
      <div className="flex gap-3">
        <Cookie className="h-5 w-5 text-amber-300 shrink-0 mt-0.5" />
        <div className="text-xs text-slate-300 t-chat leading-5">
          {text} <Link to="/legal/cookie" data-testid="cookie-banner-link" onClick={ok} className="text-cyan-300 underline underline-offset-2">Cookie e Privacy</Link>
        </div>
      </div>
      <button data-testid="cookie-ok-btn" onClick={ok} className="mt-3 w-full rounded-full py-2 text-xs font-bold bg-gradient-to-r from-violet-600 to-cyan-600">Ho capito</button>
    </div>
  );
}
